export default __webpack_public_path__ + "static/live-shape-bg-10599e85d0659f1cc5a462397d187fa4.webp";